var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.004,
    height: 16.504,
    viewBox: "0 0 15.004 16.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Location",
    d: "M15.5,20.5c-3.728,0-7.5-.773-7.5-2.251,0-1.075,1.853-1.636,3.408-1.916a.375.375,0,1,1,.133.738c-2.033.368-2.791.918-2.791,1.178,0,.509,2.383,1.5,6.752,1.5s6.752-.991,6.752-1.5c0-.261-.758-.811-2.791-1.178a.375.375,0,0,1,.133-.738c1.555.281,3.408.841,3.408,1.916C23,19.731,19.23,20.5,15.5,20.5Zm6-10.5c0,4.648-5.557,8.407-5.794,8.564a.375.375,0,0,1-.416,0C15.057,18.408,9.5,14.65,9.5,10a6,6,0,1,1,12,0Zm-3.376,0A2.626,2.626,0,1,0,15.5,12.627,2.626,2.626,0,0,0,18.128,10Z",
    transform: "translate(-8 -4)",
    fill: "#003a6f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.dd2bd88c49d637204456c19a5caf116d.svg";
export { ForwardRef as ReactComponent };